import { createTheme } from '@mui/material'
import { themeOptions } from './options'
import { themePaletteDark, themePaletteLight } from './palette'

// The global light theme has options and the light palette
const themeLight = createTheme({
  ...themeOptions,
  palette: {
    ...themePaletteLight,
  },
})

// The global dark theme has options and the dark palette
const themeDark = createTheme({
  ...themeOptions,
  palette: {
    ...themePaletteDark,
  },
})

export { themeLight, themeDark }
